import { render, staticRenderFns } from "./CookiesToolbar.vue?vue&type=template&id=b2c3f122&"
import script from "./CookiesToolbar.vue?vue&type=script&lang=js&"
export * from "./CookiesToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports